var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { observer } from "mobx-react";
import MProductsStore, { transformPoolIds } from "../../../pc/views/FlashProduct/store";
import { getActiveTabIndex, } from "../../../services/product";
import { enableRefresh } from "../../utils/jsBridge";
import { ProductSkeletonContainer } from "../NormalProduct/styles.index";
import { isNotBlankArray } from "../../../utils/array";
import { ModuleLayoutStyle } from "../../../services/playground";
import ScrollLoad from "../../components/ScrollLoad";
import FlashProductCard from "./FlashProductsCard";
import FlashProductCardTag from "./FlashProductTag";
import SmallLoading from "../../components/SmallLoading";
import Calendar from "../../components/FlashProducts/Calendar";
import MobileModal from "../../components/MobileModal";
let NormalProductGroup = class NormalProductGroup extends React.Component {
    constructor(props) {
        var _a, _b;
        super(props);
        this.state = {
            activeTab: this.props.activeTab || ((_b = (_a = this.props.productModules) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.poolId) || "",
            dragPoints: null,
            modalVisible: false,
            isChangeTab: false,
        };
        this.newCardRef = React.createRef();
        this.touchDiv = React.createRef();
        this.calendarData = {
            isRemindMe: false,
            gpid: "",
            name: "",
            start: "",
            end: "",
            index: 0,
            activeId: "",
            url: "",
        };
        this.remindMe = (calendarData) => {
            this.calendarData = calendarData;
            this.setState({
                modalVisible: true,
            });
        };
        this.onLoadMoreProducts = () => __awaiter(this, void 0, void 0, function* () {
            const poolId = this.state.activeTab;
            const { productModules = [], isMultiTab } = this.props;
            const { loadProductsList, productsListMap } = this.MNormalProductStore;
            const poolIds = isMultiTab ? [poolId] : transformPoolIds(productModules);
            yield loadProductsList(poolIds, this.props.onLoadPool);
            const products = productsListMap === null || productsListMap === void 0 ? void 0 : productsListMap[poolId];
            return { loadCount: products === null || products === void 0 ? void 0 : products.length, isError: false };
        });
        this.onChangeTab = (poolId, index) => __awaiter(this, void 0, void 0, function* () {
            this.setState({
                isChangeTab: true,
            });
            const { loadProductsList } = this.MNormalProductStore;
            if (this.props.onClickTab) {
                this.props.onClickTab(index);
            }
            if (poolId) {
                yield loadProductsList([poolId], this.props.onLoadPool, index);
                this.setState({
                    activeTab: poolId,
                    isChangeTab: false,
                });
            }
        });
        this.onTouchMove = (poolId) => (e) => {
            var _a, _b;
            if (!((_a = this.state.dragPoints) === null || _a === void 0 ? void 0 : _a.startPoint)) {
                return;
            }
            const { startPoint } = this.state.dragPoints;
            const touchTargetWrap = (_b = this.touchDiv) === null || _b === void 0 ? void 0 : _b.current;
            const touchTarget = touchTargetWrap === null || touchTargetWrap === void 0 ? void 0 : touchTargetWrap.children[0];
            if (!touchTarget) {
                return;
            }
            const productsNum = touchTarget.children.length;
            const parentScrollLeft = touchTarget.scrollLeft;
            const middleProduct = touchTarget.children[productsNum - 1];
            const middleProductLeft = middleProduct.offsetLeft / 2;
            if (parentScrollLeft >= middleProductLeft) {
                this.MNormalProductStore.loadProductsList([poolId], this.props.onLoadPool);
            }
            if (this.isDragging) {
                const touch = e.touches[0];
                const endPoint = {
                    x: touch.clientX,
                    y: touch.clientY,
                };
                const a = Math.abs(endPoint.x - startPoint.x);
                const b = Math.abs(endPoint.y - startPoint.y);
                if (endPoint.y - startPoint.y > 0 &&
                    Math.abs((Math.atan2(b, a) * 180) / Math.PI) >= 60) {
                    enableRefresh({ refresh: true });
                }
            }
        };
        this.onTouchStart = (e) => {
            const touch = e.touches[0];
            const dragPoints = {
                startPoint: {
                    x: touch.clientX,
                    y: touch.clientY,
                },
            };
            this.setState({ dragPoints });
            enableRefresh({ refresh: false });
        };
        this.onTouchEnd = () => {
            enableRefresh({ refresh: true });
        };
        this.onClickProduct = (i, pid) => {
            this.props.SetCtrTrackOnAction && this.props.SetCtrTrackOnAction(i, pid);
        };
        this.renderMProductsList = (poolId) => {
            const { layout, placeholderBg, isInApp, tagGroup = [], isMultiTab, layoutStyle = ModuleLayoutStyle.Orange, } = this.props;
            const { activeTab } = this.state;
            const products = this.MNormalProductStore.productsListMap[poolId];
            if (!products) {
                return null;
            }
            const activeTabIndex = getActiveTabIndex({ tagGroup, activeTab });
            return [
                (products || []).map((pool, index) => {
                    var _a, _b;
                    return (React.createElement(FlashProductCard, { columnNum: layout.columnNum || 2, key: pool.gpid, onClick: () => this.onClickProduct(index.toString(), pool.gpid), productElement: pool, index: index, stylesForCard: this.props.stylesForCard, placeholderBg: placeholderBg, isInApp: !!isInApp, isActView: (_a = tagGroup[activeTabIndex]) === null || _a === void 0 ? void 0 : _a.isActive, multiTab: !!isMultiTab, activeId: pool.gpid, state: pool.state || ((_b = tagGroup[activeTabIndex]) === null || _b === void 0 ? void 0 : _b.state), layoutStyle: layoutStyle, remindMe: this.remindMe }));
                }),
            ];
        };
        this.MNormalProductStore = new MProductsStore(props.productModules);
    }
    get isDragging() {
        return this.state.dragPoints !== null;
    }
    render() {
        var _a;
        const { className = "", positionId, stickToTop = 0, canScrollFixed, tagGroup = [], layout, isMultiTab, } = this.props;
        const { modalVisible, activeTab: poolId } = this.state;
        const currentElement = (_a = this.newCardRef) === null || _a === void 0 ? void 0 : _a.current;
        let loading = poolId ? this.MNormalProductStore.isLoadingProducts[poolId] : false;
        const { gap = 0.5, columnNum = 2, parentGap = 0.5 } = layout;
        loading = loading || this.state.isChangeTab;
        return (React.createElement("section", { id: positionId, ref: this.newCardRef, className: className },
            isNotBlankArray(tagGroup) && isMultiTab && (React.createElement(FlashProductCardTag, { activeTab: poolId, canScrollFixed: !!canScrollFixed, clientElement: currentElement, stickToTop: stickToTop, tagGroup: tagGroup, onChange: this.onChangeTab })),
            React.createElement(ScrollLoad, { StyleComponent: ProductSkeletonContainer, grid: { gridCol: columnNum, gridGap: gap, parentGap }, loadFunction: this.onLoadMoreProducts },
                this.renderMProductsList(poolId),
                loading && React.createElement(SmallLoading, null)),
            React.createElement(MobileModal, { visible: modalVisible },
                React.createElement(Calendar, { closeModal: () => this.setState({ modalVisible: false }), calendarData: this.calendarData, activeId: poolId, onReminder: this.props.setProductsRemindWithUser }))));
    }
};
NormalProductGroup.defaultProps = {
    productModules: [],
    isMultiTab: true,
    tagGroup: [],
};
NormalProductGroup = __decorate([
    observer
], NormalProductGroup);
export default NormalProductGroup;
